// src/components/Tutorial/tutorialSteps.js

export const getTutorialSteps = (isMobile) => [
  {
    title: 'Welcome to OnlyStats',
    content: 'Welcome to your personalized dashboard! 🎉\n\nOnlyStats helps you make smarter decisions about OnlyFans creators by providing honest, verified reviews from real subscribers.\n\n• Read detailed reviews before subscribing\n• Share your own experiences to help others\n• Earn money by referring friends\n\nLet\'s get started!',
    showMiniNav: false
  },
  {
    title: 'Navigation Overview',
    content: isMobile 
      ? 'Your navigation is located at the bottom of your screen for easy thumb access. Tap any icon to explore different sections of the app.'
      : 'Your navigation is located at the top of your screen. Click any icon to explore different sections of the app.',
    showMiniNav: true,
    isMobile: isMobile
  },
  {
    title: 'Your Profile Dashboard',
    content: 'Your Profile is your control center! Here you can:\n\n• View and manage your OnlyFans subscriptions\n• See your account status and verification\n• Access your referral link to earn money\n• Contact support if you need help\n\nEverything you need is right here.',
    showMiniNav: false,
    showProfileExample: true
  },
  {
    title: 'Verify Your Account',
    content: 'Verify your OnlyFans account to unlock verified reviews! Your reviews will be marked as "Verified" and weighted more heavily.\n\n⚠️ Only password-based accounts can be verified. Google OAuth and X login accounts cannot be verified.',
    showMiniNav: false,
    showVerificationExample: true
  },
  {
    title: 'Managing Your Subscriptions',
    content: 'The "OnlyFans Subscriptions" section shows all your connected subscriptions. You can:\n\n• See which creators you\'ve reviewed\n• Leave reviews for creators you\'re subscribed to\n• Refresh your subscription list\n• Verify your account to unlock verified reviews',
    showMiniNav: false,
    showSubscriptionExample: true
  },
  {
    title: 'Writing Reviews',
    content: 'Share your honest experience! When reviewing a creator, you can rate:\n\n• Content Quality\n• Content Frequency\n• Authenticity\n• Consistency\n• Engagement\n\nPlus add a detailed written review. Verified subscribers\' reviews are marked and weighted more heavily, helping others trust your feedback.',
    showMiniNav: false,
    showReviewExample: true
  },
  {
    title: 'Earn with Referrals',
    content: 'Share your unique referral link and earn $1 for every friend who signs up for VIP! 💰\n\n• Copy your referral link from your dashboard\n• Share it with friends\n• Earn $1 for each VIP signup\n• Track your earnings in real-time\n\nIt\'s that simple!',
    showMiniNav: false,
    showReferralExample: true
  },
  {
    title: 'Browse Creators',
    content: 'Discover new creators in the Creators section! Each profile shows:\n\n• Reviews and ratings\n• Average scores\n• Subscription links\n• Detailed statistics\n\nFind your next favorite creator with confidence.',
    showMiniNav: false,
    showCreatorsExample: true
  },
  {
    title: 'Need Help?',
    content: 'We\'re here to help! Use the "Contact Support" button in your dashboard to:\n\n• Report issues\n• Ask questions\n• Get assistance with verification\n• Provide feedback\n\nOur support team responds quickly to all inquiries.',
    showMiniNav: false,
    showSupportExample: true
  },
  {
    title: 'You\'re All Set! 🎉',
    content: 'You now know everything you need to get started with OnlyStats!\n\n• Start by verifying your account to unlock verified reviews\n• Review your current subscriptions\n• Share your referral link to start earning\n• Explore creators and help others make better decisions\n\nHappy reviewing!',
    showMiniNav: false
  }
];
